import { fetchLastUpdatedAt } from "@/components/Leaderboard/actions"
import { useQuery } from "@tanstack/react-query"

const ONE_WEEK = 7 * 24 * 60 * 60 * 1000

const getPointsLastUpdated = async (): Promise<{ lastUpdatedAt: string; nextUpdate: string } | undefined> => {
  const lastUpdated = await fetchLastUpdatedAt()

  //The date stored is not a timestamp, it is in the form 12-4-24 and thus when returned it is
  //assumed to be utc and thus the date is off by 12 hours.

  // Offsetting another 24 hours in order to properly display the date points were 
  // calculated which only includes token holdings data up till but not including the current day.
  let lastUpdatedDate = !!lastUpdated ? new Date(lastUpdated) : undefined
  if (lastUpdatedDate) {
    lastUpdatedDate.setHours(lastUpdatedDate.getHours() + 12 + 24)
  }

  const lastUpdatedAtString = lastUpdatedDate
    ? lastUpdatedDate.toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })
    : "-"
  const nextUpdate = lastUpdatedDate
    ? new Date(lastUpdatedDate.valueOf() + ONE_WEEK).toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
      })
    : "-"

  return { lastUpdatedAt: lastUpdatedAtString, nextUpdate }
}

export default function usePointsLastUpdated() {
  return useQuery({
    queryKey: ["points_last_updated"],
    queryFn: () => getPointsLastUpdated(),
    refetchOnWindowFocus: false,
  })
}
